// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4340":"b519f623","6856":"feff1096","7741":"3b87ce18"}[chunkId] + ".chunk.css";
};